import LinearProgress from "@mui/material/LinearProgress"
import React, { FC, useState } from "react"

import {
  AdvancedForm,
  AdvancedFormStepProps,
} from "src/components/common/advancedForm"

import { Drawer } from "src/components/common/drawer"
import { BasicLayoutStyleProps } from "src/components/layouts/basic"
import { create } from "src/helpers/bem"
import { formatFormData } from "src/helpers/form"
import { postForm } from "src/queriesXRM/form"
import {
  useBooking,
  setDetailActiveStep,
  mergeDetailFormField,
  mergeBookingDetail,
} from "src/states/bookingDetail"
import { resetSalesorder } from "src/states/salesorder"

import { TranslationMessages } from "src/translations"
import { xRMApiSalesorderPhase, xRMApiStep } from "src/types/xRM"

import { loadBooking } from "./BookingDetail"

import styles from "./BookingDetailForm.module.scss"

const bem = create(styles, "BookingDetailForm")

export type BookingDetailFormProps = {
  messages: TranslationMessages
  style?: BasicLayoutStyleProps
}

export const BookingDetailForm: FC<BookingDetailFormProps> = ({
  messages,
  style,
}) => {
  const formTranslations = messages.pages.standBooking
  const [loading, setLoading] = useState(false)
  const { detail, booking, bookingFormOpen } = useBooking()

  const onSendForm = async (phase?: xRMApiSalesorderPhase | "NewDraft") => {
    setLoading(true)
    const xrmPhase = phase === "NewDraft" ? "Draft" : phase
    const data = await formatFormData(
      "Main",
      detail?.activeStep,
      detail?.steps as ReadonlyArray<xRMApiStep>,
      undefined,
      booking?.id,
      xrmPhase,
    )
    return postForm(data, xrmPhase)
      .then(async () => {
        resetSalesorder()
        if (xrmPhase !== "Draft") {
          await loadBooking()
        }
        setLoading(false)
      })
      .catch(() => {
        setLoading(false)
      })
      .finally(() => mergeBookingDetail({ bookingFormOpen: false }))
  }

  return (
    <Drawer
      anchor="right"
      open={bookingFormOpen}
      style={style}
      onClose={() => mergeBookingDetail({ bookingFormOpen: false })}
      onOpen={() => mergeBookingDetail({ bookingFormOpen: true })}
    >
      <div className={bem()}>
        <AdvancedForm
          stepLabelsClickable
          activeStep={detail?.activeStep}
          data={detail?.steps as AdvancedFormStepProps[]}
          formMessages={formTranslations}
          handleChangeActiveStep={setDetailActiveStep}
          handleMergeField={mergeDetailFormField}
          id={booking?.id !== null ? booking?.id : ""}
          messages={messages}
          buttons={{
            backButtonLabel: formTranslations.buttons.back,
            nextButtonLabel: formTranslations.buttons.next,
            draftButtonLabel: formTranslations.buttons.draft,
            finishButtonLabel: formTranslations.buttons.finish,
          }}
          onSendForm={onSendForm}
        />
        {loading && (
          <LinearProgress className={bem("loading")} color="primary" />
        )}
      </div>
    </Drawer>
  )
}
